/**
 * Coordinates the post-login OS notification prompt with other sheets
 * (import onboarding) so iOS does not stack a system alert on a RN Modal.
 */

const PROMPT_SAFETY_MS = 60_000;

let pending: Promise<void> | null = null;
let resolvePending: (() => void) | null = null;
let safetyTimer: ReturnType<typeof setTimeout> | null = null;

function settle(): void {
  if (safetyTimer) {
    clearTimeout(safetyTimer);
    safetyTimer = null;
  }
  resolvePending?.();
  resolvePending = null;
  pending = null;
}

/** Call synchronously at the start of a real login, before auth state updates. */
export function markPendingLoginNotificationPrompt(): void {
  if (pending) return;
  pending = new Promise<void>((resolve) => {
    resolvePending = resolve;
  });
  safetyTimer = setTimeout(settle, PROMPT_SAFETY_MS);
}

export function completeLoginNotificationPrompt(): void {
  settle();
}

export function waitForLoginNotificationPrompt(): Promise<void> {
  return pending ?? Promise.resolve();
}
